// extracted by mini-css-extract-plugin
module.exports = {"rodape":"styles_rodape__1RZre"};